import React from "react";
import { TrendingUp, Heart, GraduationCap, ArrowRight } from "lucide-react";
import { services } from "../mock";

const iconMap = {
  TrendingUp: TrendingUp,
  Heart: Heart,
  GraduationCap: GraduationCap
};

const ServicesOverview = () => {
  const scrollToServices = () => {
    const element = document.querySelector("#services");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="py-24 bg-slate-950 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            AI Solutions Across <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-400">Key Industries</span>
          </h2>
          <p className="text-xl text-slate-400">
            Delivering transformative AI technology tailored to your sector's unique challenges
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-cyan-500/20"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-cyan-500/20 to-teal-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-cyan-500/30">
                  <IconComponent className="w-8 h-8 text-cyan-400" />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors duration-300">
                  {service.sector}
                </h3>
                <h4 className="text-lg font-semibold text-slate-300 mb-4">{service.title}</h4>
                <p className="text-slate-400 mb-6 leading-relaxed">{service.description}</p>

                {/* Learn More Link */}
                <button
                  onClick={scrollToServices}
                  className="flex items-center space-x-2 text-cyan-400 font-semibold group-hover:text-cyan-300 transition-colors duration-300"
                >
                  <span>Learn More</span>
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
                </button>

                {/* Hover Gradient Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-teal-500/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;